__turbopack_context__.v({
  "item": "AcsNavItem-module-scss-module__TBBnbG__item",
  "link": "AcsNavItem-module-scss-module__TBBnbG__link",
  "list": "AcsNavItem-module-scss-module__TBBnbG__list",
});
